import type { MsRecommendationProcessedResponse } from '../../interfaces/msRecommendation';
import type { Recommendations } from '../../interfaces/productRecommendation';

export const TRIGGER_A2C_RECOS = 'productDiscovery/TRIGGER_A2C_RECOS';

// SERVICE: ms.reco
export const FETCH_RECOMMENDATION_CONFIG =
  'productDiscovery/Recommendations/ProductRecommendation/FETCH_RECOMMENDATION_CONFIG';
export const FETCH_RECOMMENDATION_CONFIG_SUCCESS =
  'productDiscovery/Recommendations/ProductRecommendation/FETCH_RECOMMENDATION_CONFIG_SUCCESS';
export const FETCH_RECOMMENDATION_CONFIG_FAILED =
  'productDiscovery/Recommendations/ProductRecommendation/FETCH_RECOMMENDATION_CONFIG_FAILED';

// SERVICE: algolia
export const FETCH_RECOMMENDATION =
  'productDiscovery/Recommendations/ProductRecommendation/FETCH_RECOMMENDATION';

export const FETCH_PRODUCTS_RECOMMENDATION =
  'productDiscovery/Recommendations/ProductRecommendation/FETCH_PRODUCTS_RECOMMENDATION';
export const FETCH_PRODUCTS_RECOMMENDATION_SUCCESS =
  'productDiscovery/Recommendations/ProductRecommendation/FETCH_PRODUCTS_RECOMMENDATION_SUCCESS';
export const FETCH_PRODUCTS_RECOMMENDATION_FAILED =
  'productDiscovery/Recommendations/ProductRecommendation/FETCH_PRODUCTS_RECOMMENDATION_FAILED';

export const CONFIG_PROCESSING_SUCCESS =
  'productDiscovery/Recommendations/ProductRecommendation/CONFIG_PROCESSING_SUCCESS';
export const CONFIG_PROCESSING_FAILED =
  'productDiscovery/Recommendations/ProductRecommendation/CONFIG_PROCESSING_FAILED';

// ** MERCH-461 / REC-2739 ***
// SERVICE: ms.catalog-category
// export const FETCH_CATEGORIES_RECOMMENDATION =
//   'productDiscovery/Recommendations/ProductRecommendation/FETCH_CATEGORIES_RECOMMENDATION';
// export const FETCH_CATEGORIES_RECOMMENDATION_SUCCESS =
//   'productDiscovery/Recommendations/ProductRecommendation/FETCH_CATEGORIES_RECOMMENDATION_SUCCESS';
// export const FETCH_CATEGORIES_RECOMMENDATION_FAILED =
//   'productDiscovery/Recommendations/ProductRecommendation/FETCH_CATEGORIES_RECOMMENDATION_FAILED';

export interface TriggerA2CRecos {
  type: typeof TRIGGER_A2C_RECOS;
  payload: { categoryId: number };
}

export const triggerA2CRecos = (categoryId: number): TriggerA2CRecos => ({
  type: TRIGGER_A2C_RECOS,
  payload: { categoryId },
});

// ACTION: FETCH_RECOMMENDATION_CONFIG
export interface FetchRecommendationConfig {
  type: typeof FETCH_RECOMMENDATION_CONFIG;
}

export const fetchRecommendationConfig = (): FetchRecommendationConfig => ({
  type: FETCH_RECOMMENDATION_CONFIG,
});

// SUCCESS
export interface FetchRecommendationConfigSuccess {
  type: typeof FETCH_RECOMMENDATION_CONFIG_SUCCESS;
  config: MsRecommendationProcessedResponse;
}

export const fetchRecommendationConfigSuccess = (
  config: MsRecommendationProcessedResponse,
): FetchRecommendationConfigSuccess => ({
  type: FETCH_RECOMMENDATION_CONFIG_SUCCESS,
  config,
});

// FAILED
export interface FetchRecommendationConfigFailed {
  type: typeof FETCH_RECOMMENDATION_CONFIG_FAILED;
  error: Error;
}

export const fetchRecommendationConfigFailed = (
  error: Error,
): FetchRecommendationConfigFailed => ({
  type: FETCH_RECOMMENDATION_CONFIG_FAILED,
  error,
});

// ACTION: FETCH_PRODUCTS_RECOMMENDATION
export interface FetchProductRecommendation {
  type: typeof FETCH_PRODUCTS_RECOMMENDATION;
}

export const fetchProductsRecommendation = (): FetchProductRecommendation => ({
  type: FETCH_PRODUCTS_RECOMMENDATION,
});

// SUCCESS
export interface FetchProductRecommendationSuccess {
  type: typeof FETCH_PRODUCTS_RECOMMENDATION_SUCCESS;
  recommendations: Recommendations;
}

export const fetchProductsRecommendationSuccess = (
  recommendations: Recommendations,
): FetchProductRecommendationSuccess => ({
  type: FETCH_PRODUCTS_RECOMMENDATION_SUCCESS,
  recommendations,
});

// FAILED
export interface FetchProductRecommendationFailed {
  type: typeof FETCH_PRODUCTS_RECOMMENDATION_FAILED;
  error: Error;
}

export const fetchProductsRecommendationFailed = (
  error: Error,
): FetchProductRecommendationFailed => ({
  type: FETCH_PRODUCTS_RECOMMENDATION_FAILED,
  error,
});

export interface ConfigProcessingSuccess {
  type: typeof CONFIG_PROCESSING_SUCCESS;
  config: MsRecommendationProcessedResponse;
}

export const setConfigProcessingSuccess = (
  config: MsRecommendationProcessedResponse,
): ConfigProcessingSuccess => ({
  type: CONFIG_PROCESSING_SUCCESS,
  config,
});

export interface ConfigProcessingFailed {
  type: typeof CONFIG_PROCESSING_FAILED;
  error: Error;
}

export const setConfigProcessingFailed = (
  error: Error,
): ConfigProcessingFailed => ({
  type: CONFIG_PROCESSING_FAILED,
  error,
});

export interface FetchRecommendation {
  type: typeof FETCH_RECOMMENDATION;
  config: MsRecommendationProcessedResponse;
}

export const fetchRecommendation = (
  config: MsRecommendationProcessedResponse,
): FetchRecommendation => ({
  type: FETCH_RECOMMENDATION,
  config,
});

export type Action =
  | FetchRecommendationConfig
  | FetchRecommendationConfigSuccess
  | FetchRecommendationConfigFailed
  | FetchProductRecommendation
  | FetchProductRecommendationSuccess
  | FetchProductRecommendationFailed
  | ConfigProcessingSuccess
  | ConfigProcessingFailed;
// ** MERCH-461 / REC-2739 ***
// | FetchCategoriesRecommendation
// | FetchCategoriesRecommendationSuccess
// | FetchCategoriesRecommendationFailed;
